export default __webpack_public_path__ + "static/softwareconsult1-c829351d9b1402fddbb54ebff59e3b40.jpg";